// Full-document render of the Oscar profile-edit view: PageSkeleton wrapping
// the legacy sealy breadcrumb shell ("Your Account / Account Information")
// and the ProfileForm rendered as a native React field tree.
import React from "react";

import { templates } from "@reactivated";

import { AccountBreadcrumbShell } from "../components/AccountBreadcrumbShell";
import { AccountForm } from "../components/AccountForm";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ProfileUpdateDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountBreadcrumbShell
            crumbs={[
                { label: "Your Account", href: props.profile_url },
                { label: "Account Information" },
            ]}
            heading="Account Information"
        >
            <AccountForm {...props} />
        </AccountBreadcrumbShell>
    </PageSkeleton>
);
